import styled from 'styled-components'

interface CorpoConteudoProps {
  rowGap?: string
  minHeight?: string
}

export const CorpoConteudo = styled.main<CorpoConteudoProps>`
  display: flex;
  flex-direction: column;
  margin-bottom: 60px;
  min-height: ${(props) => props.minHeight || '100vh'};
  position: relative;
  row-gap: ${(props) => props.rowGap || '15px'};
  top: 60px;
  width: 100%;
`
